export default __webpack_public_path__ + "static/media/success-flag.980d2464.png";